import React from 'react';

import NotFoundModule from '../components/PageGates/NotFoundModule';

export default function PageNotFound() {
  return <NotFoundModule />;
}
